import { render } from "./UserProjectTable.vue?vue&type=template&id=6c1f93b2"
import script from "./UserProjectTable.vue?vue&type=script&lang=js"
export * from "./UserProjectTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__